import defaultConfig from './envs/default.env'
import local from './envs/local.env'
import dev from './envs/dev.env'
import prod from './envs/prod.env'
import {
	adminMenu,
	sidePageList,
	MenuType,
	SidePageType,
	defaultMenu,
	mobileMenuList,
	homeMenuList,
	visibleCustomerMenu,
	supportSubMenuList,
	productSubMenuList,
} from './menu.config'
import { icons } from './icon.config'
import { southKoreaDistrict, ProvinceType } from './southKoreaDistrict.config'
import { fileIcon, FileIconType } from './fileIcon.config'
import { manualUrlList } from './manual.config'

export type { MenuType, SidePageType } from './menu.config'
// 사이트 밖 주소 — `@configs` 는 이 파일 하나만 가리켜서 여기로 내보낸다 (2026-09-10 Forum 오픈)
export {
	FORUM_URL,
	isExternalUri,
	visibleCustomerMenu,
	customerRoleRequiredByPath,
	customerRoleRequiredFor,
} from './menu.config'
export {
	pickSiteToken,
	dropSiteToken,
	clearSiteSession,
	forumEntryUrl,
	POST_LOGIN_REDIRECT_KEY,
} from './forum.config'
export type { FileIconType } from './fileIcon.config'
// 문의 게시판 관리 상수 — 카드·드로어·사가가 같이 쓴다
export {
	INQUIRY_STATUS_OPTIONS,
	INQUIRY_FILTER_OPTIONS,
	INQUIRY_STATUS_COLOR,
	INQUIRY_STATUS_LABEL,
	INQUIRY_CATEG_LABEL,
	INQUIRY_PAGE_SIZE,
	INQUIRY_DRAWER_WIDTH,
	INQUIRY_REPLY_FROM_ADDRESS,
	INQUIRY_REPLY_FROM_NAME,
	INQUIRY_SUBJECT_PATTERN,
	customerFacingStaffName,
} from './inquiryMgmt.config'
import { HomeNavMenuType } from '@redux/index'

const config = {
	get: (searchGroup = '') => {
		try {
			const tempEnv: string = process.env.REACT_APP_NODE_ENV ?? ''
			const env: string = tempEnv.toString().toUpperCase()
			const environment: { [key: string]: any } =
				env === 'PROD' ? prod : env === 'LOCAL' ? local : dev
			const result: { [key: string]: any } = util.merge(defaultConfig, environment)

			if (searchGroup === '') {
				return result
			} else {
				return result[searchGroup]
			}
		} catch (error) {
			console.warn(error)
		}
	},

	defaultMenu: (): MenuType => defaultMenu,

	adminMenu: (): MenuType[] => {
		const menuList: MenuType[] = adminMenu
		return menuList
	},
	sidePage: (): SidePageType[] => {
		const sidePageeList: SidePageType[] = sidePageList
		return sidePageeList
	},

	homeMenu: (): HomeNavMenuType[] => {
		const homeMenu: HomeNavMenuType[] = homeMenuList
		return homeMenu
	},

	/** 계정 메뉴. 역할 항목은 넘긴 역할이 있을 때만 든다 — 생략하면 공통 항목만 */
	customerMenu: (customerRoles: string[] = []): HomeNavMenuType[] => {
		const menu: HomeNavMenuType[] = visibleCustomerMenu(customerRoles)
		return menu
	},

	supportMenu: (): HomeNavMenuType[] => {
		const menu: HomeNavMenuType[] = supportSubMenuList
		return menu
	},

	productMenu: (): HomeNavMenuType[] => {
		const menu: HomeNavMenuType[] = productSubMenuList
		return menu
	},

	mobileMenuList: mobileMenuList,

	icons: (): string[] => {
		const iconList: string[] = icons
		return iconList
	},

	province: (): string[] => {
		const totalDistrict: ProvinceType = southKoreaDistrict

		return Object.keys(totalDistrict)
	},

	city: (province = ''): string[] => {
		const totalDistrict: ProvinceType = southKoreaDistrict

		const idx = Object.keys(totalDistrict).indexOf(province)
		const cities = idx > -1 ? totalDistrict[province] : []

		return cities
	},
	fileIcon: (ext: string): FileIconType => {
		const res: FileIconType =
			ext === ''
				? {
						color: '',
						labelColor: '',
						glyphColor: '',
						mimeType: '',
				  }
				: fileIcon[ext]
		return res
	},

	manual: (code: string) => {
		const res = manualUrlList[code]
		return res
	},
}

const util = {
	isObject: (value: any) => {
		return value !== null && typeof value === 'object' && !Array.isArray(value)
	},

	merge: (
		target: { [key: string]: any },
		source: { [key: string]: any },
	): { [key: string]: any } => {
		for (const key of Object.keys(source)) {
			const targetValue: any = target[key]
			const sourceValue: any = source[key]
			if (util.isObject(targetValue) && util.isObject(sourceValue)) {
				Object.assign(
					sourceValue,
					util.merge(targetValue as object, sourceValue as object),
				)
			}
		}

		return { ...target, ...source }
	},
}

export default config
